export default "__VITE_ASSET__sI6m2sZD__"